import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext(null);

/**
 * Provides shared state across all pages:
 *   - modalOpen: controls the global success modal
 *   - selectedLevel: active JLPT level (N5 / N4 / N3)
 */
export function AppProvider({ children }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedLevel, setSelectedLevel] = useState('N5');

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
    <AppContext.Provider
      value={{ modalOpen, openModal, closeModal, selectedLevel, setSelectedLevel }}
    >
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useApp must be used within AppProvider');
  return ctx;
}

export default AppContext;
